import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import PopularSection from "./components/PopularSection";
import LatestSection from "./components/LatestSection";
import ArticleSection from "./components/ArticleSection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "韩漫漫画网",
    url: typeof window !== "undefined" ? window.location.origin : "",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "/search?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
    description:
      "韩漫漫画网汇聚免费韩漫、海量漫画大全、优质在线漫画及精选韩国漫画，致力于提供专业的阅读服务。",
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "韩漫漫画网",
    url: typeof window !== "undefined" ? window.location.origin : "",
    description:
      "韩漫漫画网汇聚免费韩漫、海量漫画大全、优质在线漫画及精选韩国漫画，致力于提供专业的阅读服务。",
    contactPoint: {
      "@type": "ContactPoint",
      email: "contact@manhuacomic.com",
      contactType: "customer service",
      availableLanguage: "Chinese",
    },
  };

  return (
    <>
      <SEO
        title="免费韩漫,漫画大全,在线漫画,韩国漫画-韩漫漫画网"
        description="韩漫漫画网汇聚免费韩漫、海量漫画大全、优质在线漫画及精选韩国漫画，致力于提供专业的线上漫画阅读服务。每日更新热门韩漫，支持手机与电脑在线阅读。"
        keywords="免费韩漫,漫画大全,在线漫画,韩国漫画,韩漫漫画网"
        canonicalUrl={typeof window !== "undefined" ? window.location.origin + "/" : "/"}
        ogImage="https://readdy.ai/api/search-image?query=Korean%20webtoon%20artistic%20banner%20with%20multiple%20manga-style%20characters%20and%20soft%20warm%20gradient%20background%2C%20clean%20minimal%20design%2C%20reading%20theme&width=1200&height=630&seq=og-homepage&orientation=landscape"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />

      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <PopularSection />
        <LatestSection />
        <ArticleSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}